"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var app_1 = require("../app");
var query_get_charge_order_number_1 = require("../graphql/query_get_charge_order_number");
var react_hooks_1 = require("@apollo/react-hooks");
var address_display_1 = __importDefault(require("../components/address_display"));
var order_summary_1 = __importDefault(require("../components/order_summary"));
var react_router_dom_1 = require("react-router-dom");
var DLEnhancedEcomm = __importStar(require("../helpers/data_layer"));
var useContext = react_1.default.useContext;
exports.default = (function () {
    var context = useContext(app_1.CheckoutContext);
    if (!context)
        return null;
    var imageUrls = context.imageUrls, shippingAddress = context.shippingAddress, chargeId = context.chargeId, checkoutComplete = context.checkoutComplete, email = context.email, cart = context.cart, priceTotal = context.priceTotal, priceTaxes = context.priceTaxes, shippingMethod = context.shippingMethod, discountCode = context.discountCode, priceSubtotal = context.priceSubtotal, dataLayerPushEvent = context.dataLayerPushEvent, customer = context.customer;
    var _a = __read((0, react_hooks_1.useLazyQuery)(query_get_charge_order_number_1.GET_CHARGE_ORDER_NUMBER), 2), getOrderName = _a[0], chargeData = _a[1].data;
    var history = (0, react_router_dom_1.useHistory)();
    var containsSubscription = (0, react_1.useMemo)(function () { return cart.lineItems.some(function (li) { return li.properties && !!li.properties.subscription_id; }); }, []);
    (0, react_1.useEffect)(function () {
        if (!checkoutComplete) {
            history.push('/');
            return;
        }
        if (chargeId) {
            getOrderName({ variables: { chargeId: chargeId } });
        }
    }, [chargeId]);
    (0, react_1.useEffect)(function () {
        var e_1, _a;
        var charge = chargeData === null || chargeData === void 0 ? void 0 : chargeData.charge;
        if (charge) {
            var standardDLEcommerceData = {
                transactionId: charge.shopify_order.id,
                transactionTotal: priceTotal,
                transactionSubtotal: priceSubtotal,
                transactionShipping: shippingMethod === null || shippingMethod === void 0 ? void 0 : shippingMethod.price,
                transactionTax: priceTaxes,
                transactionProducts: [],
            };
            try {
                for (var _b = __values(cart.lineItems), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var li = _c.value;
                    standardDLEcommerceData.transactionProducts.push({
                        sku: li.sku,
                        name: li.title,
                        price: (li.price / 100).toFixed(2),
                        quantity: li.quantity,
                    });
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_1) throw e_1.error; }
            }
            dataLayerPushEvent('checkout__complete', __assign({ chargeId: charge.shopify_order, orderId: charge.shopify_order.id, orderNumber: charge.shopify_order.name, discountCode: discountCode, email: email, shippingFirstName: shippingAddress === null || shippingAddress === void 0 ? void 0 : shippingAddress.firstName, shippingLastName: shippingAddress === null || shippingAddress === void 0 ? void 0 : shippingAddress.lastName, shippingCity: shippingAddress === null || shippingAddress === void 0 ? void 0 : shippingAddress.city, shippingZip: shippingAddress === null || shippingAddress === void 0 ? void 0 : shippingAddress.zip, shippingState: shippingAddress === null || shippingAddress === void 0 ? void 0 : shippingAddress.state, shippingCountry: shippingAddress === null || shippingAddress === void 0 ? void 0 : shippingAddress.country }, standardDLEcommerceData));
            DLEnhancedEcomm.pushCheckoutComplete({
                lineItems: cart.lineItems,
                chargeId: Number(chargeId),
                total: priceTotal,
                totalShipping: shippingMethod === null || shippingMethod === void 0 ? void 0 : shippingMethod.price,
                totalTax: priceTaxes,
                discountCode: discountCode,
            });
        }
    }, [chargeData === null || chargeData === void 0 ? void 0 : chargeData.charge]);
    return (react_1.default.createElement("div", { className: 'text-center margin-bottom-5 margin-top-5' },
        react_1.default.createElement("h4", { className: 'h4' }, "Thank you for your purchase!"),
        react_1.default.createElement("img", { src: imageUrls.orderConfirmation, className: 'padding-left-12 padding-right-10' }),
        react_1.default.createElement("p", { className: 'margin-bottom-4 margin-top-4 text-gray font-lighter' },
            "We'll send out a confirmation and shipping update to ",
            react_1.default.createElement("strong", null, email)),
        chargeData && chargeData.charge && react_1.default.createElement("p", { className: 'margin-bottom-2 font-lighter' },
            "Order ",
            chargeData.charge.shopify_order.name),
        containsSubscription && !customer && (react_1.default.createElement("div", null,
            react_1.default.createElement("p", { className: 'margin-bottom-2 font-lighter' }, "Create an account to manage your subscription"),
            react_1.default.createElement("a", { href: "/account/register/?email=".concat(email), className: 'button btn-form margin-bottom-2' }, "CREATE ACCOUNT"))),
        !containsSubscription && (react_1.default.createElement("div", null,
            react_1.default.createElement("a", { href: "/account/register/?email=".concat(email), className: 'button btn-form margin-bottom-2' }, "CONTINUE SHOPPING"))),
        react_1.default.createElement("hr", { className: 'margin-top-10 margin-bottom-10' }),
        react_1.default.createElement("div", { className: 'panel' },
            react_1.default.createElement("h4", { className: 'h5' }, "Shipping Address"),
            shippingAddress && react_1.default.createElement(address_display_1.default, { address: shippingAddress, showCountry: false })),
        react_1.default.createElement("div", { className: 'hide-for-medium' },
            react_1.default.createElement("div", { className: 'small-12 margin-top-8 ', style: { marginLeft: '-16px', marginRight: '-16px' } },
                react_1.default.createElement(order_summary_1.default, { expanded: true, expandable: false })))));
});
